import React, { useEffect, useState } from "react";
import { Rating } from "@mui/material";
import config from "@/config/config";
import GoogleReviewSummary from "./GoogleStars";
import { Link } from "react-router-dom";

const GoogleTestimonials = ({ title }) => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await fetch(`${config.apiUrl}/api/reviews`);
        const data = await response.json();
        setReviews(data.slice(0, 3)); // Show only top 3 reviews
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };

    fetchReviews();
  }, []);

  return (
    <section className="py-12 sm:py-16 bg-gray-5 lg:py-10">
      <hr className="pb-10 w-10/12 mx-auto border-prime-900/30" />
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="flex flex-col items-center">
          <div className="text-center flex flex-col items-center">
            <h2 className="mt-4 text-3xl font-semibold font-sans text-prime-950 sm:text-4xl xl:text-5xl">
              {title || "Das sagen unsere Kunden"}
            </h2>
            <GoogleReviewSummary />
          </div>

          <div className="mt-10 md:mt-16 grid max-w-lg py-10 grid-cols-1 gap-6 mx-auto md:max-w-none lg:gap-10 md:grid-cols-3">
            {reviews.map((review, index) => (
              <div
                key={index}
                className="flex cursor-pointer hover:bg-white   transition-all duration-300 flex-col overflow-hidden  bg-gray-100 p-6 lg:py-8 lg:px-7 rounded-lg"
              >
                <div className="flex-1">
                  <div className="flex items-center">
                    <Rating value={review.rating} precision={0.1} readOnly />
                  </div>
                  <blockquote className="flex-1 mt-4">
                    <p className="text-lg italic leading-relaxed text-gray-600">
                      "
                      {review.text.length > 120
                        ? `${review.text.substring(0, 120)}...`
                        : review.text}
                      "
                    </p>
                  </blockquote>
                </div>
                <div className="flex items-center mt-6">
                  <img
                    className="w-11 h-11 rounded-full object-cover"
                    src={
                      review.profile_photo_url ||
                      "https://via.placeholder.com/50"
                    }
                    alt={review.author_name}
                  />
                  <div className="ml-4">
                    <p className="text-base font-semibold text-prime-950">
                      {review.author_name}
                    </p>
                    <p className="text-sm text-gray-600">
                      {new Date(review.time * 1000).toLocaleDateString("de-DE")}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center md:mt-12">
            <Link
              target="__blanc"
              to={"/referenzen"}
              className="pb-2 text-base font-bold leading-7 text-gray-900 border-b-2 cursor-pointer font-serif border-gray-900 hover:text-gray-600"
            >
              Alle Referenzen ansehen
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GoogleTestimonials;
